/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import {
  Alert,
  Button,
  Center,
  Group,
  Loader,
  Menu,
  Modal,
  Paper,
  Space,
  Text,
  ThemeIcon,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import {
  IconAlertTriangle,
  IconCalendarRepeat,
  IconCirclesRelation,
  IconDatabase,
  IconDeviceFloppy,
  IconEye,
  IconId,
} from '@tabler/icons-react';
import moment from 'moment';
import { Tabs } from 'antd';
import { useEffect, useRef, useState } from 'react';
import {
  AudienciaCodigo,
  Fonte,
  ReferenciaCodigo,
  Relacao,
  Status,
  TipoCodigo,
} from '../../../../business/events/general';
import { useEventGeneralContext } from '../../../../contexts/core/events/EventGeneral.context';
import useCurrentUser from '../../../../hooks/useCurrentUser';
import {
  CompanyType,
  ContractStatusType,
  DocumentType,
  EntityTypeType,
  EventRelationTypeData,
  EventStatusType,
  ProposalStatusType,
  UnitOfMeasureType,
} from '../../../../models/core/cache.type';
import { ContractSearchResponseType } from '../../../../models/core/contracts.type';
import { Permission } from '../../../../models/core/departments.type';
import {
  EventSearchResponseType,
  EventSharedResidueRequestType,
  EventSharedResidueType,
  EventType,
} from '../../../../models/core/events.type';
import { UserType } from '../../../../models/core/users.type';
import eventsService from '../../../../services/core/events.service';
import { Feature } from '../../../../utils/constants.utils';
import { buildFakeAuditObject } from '../../../../utils/helper.utils';
import { DATE_FORMAT } from '../../../../utils/moment-recur.utils';
import { validate } from '../../../../utils/permission.utils';
import RecurrenceForm from '../../../../components/core/Recurrence/RecurrenceForm';
import GeneralFormView from './components/GeneralFormView';
import ReferenceFormView from './components/ReferenceFormView';
import RelationFormView from './components/RelationFormView';
import SharedResidueView from './components/SharedResidueView/SharedResidueView';

type DataResult = {
  loading: boolean;
  eventData: EventType | null;
};

type ProposalFormViewProps = {
  referenceData: {
    companyData: CompanyType[];
    proposalStatusData: ProposalStatusType[];
    contractStatusData: ContractStatusType[];
    userData: UserType[];
    entityTypeData: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
    eventRelationTypeData: EventRelationTypeData[];
    eventStatusData: EventStatusType[];
    documentTypeData: DocumentType[];
  };
  idEvento: number | undefined;
  newEventData: {
    idEmpresa: number | null;
    codigoAudiencia: AudienciaCodigo | null;
    codigoEventoTipo: TipoCodigo | null;
    fonte: Fonte | null;
    contrato: ContractSearchResponseType | null;
    codigoReferencia: ReferenciaCodigo | null;
    idUsuario: string | null;
    data: Date | null;
    descricao: string | null;
  } | null;
  callback(
    items: EventSearchResponseType[] | null,
    action: string,
    value: string | null,
    confirmed: boolean,
    extras?: any
  ): void;
  extras: any;
  zIndex: number;
};

type ModalData = {
  opened: boolean;
  event: EventType | null;
  sharedResidues: EventSharedResidueType | null;
  mode: 'single' | 'recurrence';
};

type RecurrenceModalData = {
  opened: boolean;
  event: EventType | null;
  sharedResidues: EventSharedResidueRequestType[];
};

export default function EventFormAddEdit(props: ProposalFormViewProps) {
  const [dataResult, setDataResult] = useState<DataResult>({
    loading: true,
    eventData: null,
  });
  const [currentUser] = useCurrentUser();
  const [saving, setSaving] = useState(false);
  const [modalData, setModalData] = useState<ModalData>({
    opened: false,
    event: null,
    sharedResidues: null,
    mode: 'single',
  });
  const [recurrenceModalData, setRecurrenceModalData] = useState<RecurrenceModalData>({
    opened: false,
    event: null,
    sharedResidues: [],
  });
  const { eventGeneralData } = useEventGeneralContext();

  const refGeneralForm = useRef<any>();
  const refReferenceForm = useRef<any>();
  const refRelationForm = useRef<any>();
  const refRecurrenceForm = useRef<any>();

  // TODO: Event: 006 - handle 'personalizado' flag properly
  const tabs = [
    {
      key: 'Geral',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Event.color} variant="outline">
            <IconId size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
            Geral
          </Text>
        </Group>
      ),
      children: (
        <GeneralFormView
          ref={refGeneralForm}
          event={dataResult.eventData}
          newEventData={props.newEventData}
          referenceData={props.referenceData}
          zIndex={props.zIndex + 1}
        />
      ),
      forceRender: true,
    },
    {
      key: 'Referencia',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Event.color} variant="outline">
            <IconDatabase size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
            Referência
          </Text>
        </Group>
      ),
      children: (
        <div>
          <ReferenceFormView
            ref={refReferenceForm}
            event={dataResult.eventData}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </div>
      ),
      disabled:
        !eventGeneralData.codigoEventoReferencia ||
        (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoServico &&
          !eventGeneralData.propostaServicoData) ||
        ((eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) &&
          !eventGeneralData.propostaResiduoData) ||
        ((eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) &&
          (!eventGeneralData.idEventoReferencia1 ||
            (!eventGeneralData.idEventoReferencia2 && !eventGeneralData.eventoReferenciaPersonalizado))),
      forceRender: true,
    },
    {
      key: 'Relacoes',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Event.color} variant="outline">
            <IconCirclesRelation size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
            Relações
          </Text>
        </Group>
      ),
      children: (
        <RelationFormView
          ref={refRelationForm}
          event={dataResult.eventData}
          referenceData={props.referenceData}
          zIndex={props.zIndex + 1}
        />
      ),
      forceRender: true,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      let eventData: any = null;
      try {
        if (props.idEvento) {
          eventData = await eventsService.select({ idEvento: Number(props.idEvento) });
          if (
            eventData.codigoEventoStatus === Status.Cancelado ||
            eventData.codigoEventoStatus === Status.Finalizado
          ) {
            showNotification({
              title: `Evento - Editar`,
              message: 'O evento não pode ser editado neste status.',
              color: 'red',
            });
            props.callback(null, 'callback', null, true, props.extras);
          }
        }
      } catch (err: any) {
        showNotification({
          title: `Proposta - ${!props.idEvento ? 'Adicionar' : 'Editar'}`,
          message: err?.isBusinessException ? err.description : 'Não foi possível carregar o evento.',
          color: 'red',
        });
        props.callback(null, 'callback', null, true, props.extras);
      } finally {
        setDataResult({
          loading: false,
          eventData,
        });
      }
    };

    if (!validate(!props.idEvento ? Permission.EventAdd : Permission.EventEdit, currentUser.permissoes)) {
      window.location.href = '/403';
      return;
    }

    fetchData();
  }, []);

  const normalizeInsertResponse = (response: any) => {
    response.resumoJSON = response.resumoJSON ? JSON.parse(response.resumoJSON?.toString()) : null;
    (response as any).resumoParcialJSON = response.resumoJSON;
    return response;
  };

  const insertSingleEvent = async (event: EventType, sharedResidues: EventSharedResidueRequestType[]) => {
    const response = await eventsService.insert({
      evento: event,
      residuosCompartilhados: sharedResidues,
    });
    return normalizeInsertResponse(response);
  };

  const save = async (event: EventType, sharedResidues: EventSharedResidueRequestType[]) => {
    let response = null;
    try {
      setModalData((current) => ({ ...current, opened: false }));
      setSaving(true);
      if (!props.idEvento) {
        response = await insertSingleEvent(event, sharedResidues);
      } else {
        response = await eventsService.update({
          ...event,
          idEvento: props.idEvento,
        });
      }
      showNotification({
        title: `Evento - ${!props.idEvento ? 'Adicionar' : 'Editar'}`,
        message: `Evento #${response?.idEvento || props.idEvento} salvo com sucesso.`,
        color: 'green',
      });

      props.callback([JSON.parse(JSON.stringify(response))], 'callback', null, true, props.extras);
    } catch (exception: any) {
      showNotification({
        title: `Evento - ${!props.idEvento ? 'Adicionar' : 'Editar'}`,
        message: exception?.isBusinessException ? exception.description : 'Não foi possível salvar o evento.',
        color: 'red',
      });
    } finally {
      setSaving(false);
    }
  };

  const validateEventData = () => {
    const generalData = refGeneralForm.current.validate();
    const referenceData = refReferenceForm.current.validate();
    const relacoes = refRelationForm.current.validate();

    return {
      generalData,
      event: { ...generalData, ...referenceData, relacoes },
    };
  };

  const openRecurrenceModal = (event: EventType, sharedResidues: EventSharedResidueRequestType[]) => {
    setRecurrenceModalData({
      opened: true,
      event,
      sharedResidues,
    });
  };

  const handleValidatedSubmit = async (mode: 'single' | 'recurrence') => {
    let step = 'Geral';
    try {
      const { generalData, event } = validateEventData();

      if (generalData.tempCompartilhamento) {
        setSaving(true);
        const sharedResidues = await eventsService.searchSharedResidues({
          idPropostaResiduoPlano: generalData.idEventoReferencia2!,
        });
        setSaving(false);

        if (sharedResidues) {
          setModalData({ opened: true, event, sharedResidues, mode });
          return;
        }
      }

      if (mode === 'single') {
        await save(event, []);
      } else {
        openRecurrenceModal(event, []);
      }
    } catch (error: any) {
      setSaving(false);
      if (error.message?.includes('corrigidas')) {
        step = 'Geral/Referência/Relações';
      }
      showNotification({
        title: `Evento - ${!props.idEvento ? 'Adicionar' : 'Editar'}`,
        message: `${step} - ${error.message}`,
        color: 'red',
      });
    }
  };

  const saveRecurring = async (
    event: EventType,
    sharedResidues: EventSharedResidueRequestType[],
    recurrence: any
  ) => {
    const batchSize = 10;
    const createdEvents: EventSearchResponseType[] = [];
    try {
      setSaving(true);

      const firstEvent = await insertSingleEvent(event, sharedResidues);
      createdEvents.push(JSON.parse(JSON.stringify(firstEvent)));

      const firstEventDate = moment(event.data).format('YYYY-MM-DD');
      let firstEventDateConsumed = false;
      const recurringDates = (recurrence.simulacao || [])
        .flatMap((item: { data: string; quantity: number }) =>
          Array.from({ length: Number(item.quantity || 0) }, () => item.data)
        )
        .map((date: string) => moment(date, DATE_FORMAT).format('YYYY-MM-DD'))
        .filter((date: string) => {
          if (date !== firstEventDate) {
            return true;
          }
          if (!firstEventDateConsumed) {
            firstEventDateConsumed = true;
            return false;
          }
          return true;
        })
        .sort((a: string, b: string) => moment(a).valueOf() - moment(b).valueOf());

      const processRecurringBatch = async (startIndex: number): Promise<void> => {
        if (startIndex >= recurringDates.length) {
          return;
        }

        const datesBatch = recurringDates.slice(startIndex, startIndex + batchSize);
        const createdBatch = await Promise.all(
          datesBatch.map((date: any) =>
            insertSingleEvent(
              {
                ...event,
                data: date,
              },
              sharedResidues
            )
          )
        );

        await Promise.all(
          createdBatch.map((createdEvent) =>
            eventsService.insertRelation({
              idEvento: createdEvent.idEvento,
              relacoes: [
                {
                  idEventoReferenciado: firstEvent.idEvento,
                  codigoEventoRelacao: Relacao.Recorrente,
                },
              ],
            })
          )
        );

        createdEvents.push(...createdBatch.map((x) => JSON.parse(JSON.stringify(x))));
        await processRecurringBatch(startIndex + batchSize);
      };

      await processRecurringBatch(0);

      showNotification({
        title: 'Evento - Adicionar',
        message: `${createdEvents.length} evento(s) salvos com sucesso.`,
        color: 'green',
      });

      props.callback(createdEvents, 'callback', null, true, props.extras);
    } catch (exception: any) {
      showNotification({
        title: 'Evento - Adicionar',
        message:
          exception?.isBusinessException || exception?.description
            ? exception.description
            : 'Não foi possível salvar a recorrência do evento.',
        color: 'red',
      });
    } finally {
      setSaving(false);
      setRecurrenceModalData({ opened: false, event: null, sharedResidues: [] });
    }
  };

  return (
    <div>
      {dataResult.loading ? (
        <Center>
          <Loader size="xl" />
        </Center>
      ) : (
        <div>
          <Modal
            opened={modalData.opened}
            closeOnClickOutside={false}
            closeOnEscape={false}
            size="60%"
            // centered={true}
            onClose={async () => {
              if (modalData.mode === 'single') {
                await save(modalData.event!, []);
              } else {
                openRecurrenceModal(modalData.event!, []);
              }
              setModalData({ opened: false, event: null, sharedResidues: null, mode: 'single' });
            }}
            title="Criar eventos de coleta para outros resíduos que compartilham o mesmo serviço/veículo?"
            zIndex={props.zIndex + 1}
          >
            <SharedResidueView
              sharedResidues={modalData.sharedResidues!}
              callback={async (data: any) => {
                if (modalData.mode === 'single') {
                  await save(modalData.event!, data);
                } else {
                  openRecurrenceModal(modalData.event!, data);
                }
                setModalData({ opened: false, event: null, sharedResidues: null, mode: 'single' });
              }}
              zIndex={props.zIndex + 1}
            />

            {/* <Group justify="right">
              <Button
                // color={modalData?.action === 'cancelar' ? 'orange' : 'red'}
                // leftSection={<IconCheck size={18} />}
                color="primary"
                onClick={async () => {
                  await save(modalData.event!, modalData.sharedResidues);
                  setModalData({ opened: false, event: null, sharedResidues: null });
                }}
              >
                Continuar
              </Button>
            </Group> */}
          </Modal>

          <Modal
            opened={recurrenceModalData.opened}
            closeOnClickOutside={false}
            closeOnEscape={false}
            size="80%"
            onClose={() => {
              setRecurrenceModalData({ opened: false, event: null, sharedResidues: [] });
            }}
            title="Salvar recorrência"
            zIndex={props.zIndex + 2}
          >
            <RecurrenceForm
              ref={refRecurrenceForm}
              idPropostaRecorrencia={null}
              title="Recorrência"
              description="Configure as datas para criar os eventos recorrentes."
              color={Feature.Home.Event.color}
              minDate={recurrenceModalData.event ? new Date(recurrenceModalData.event.data) : undefined}
              maxDate={undefined}
              dataInicial={recurrenceModalData.event ? new Date(recurrenceModalData.event.data) : null}
              dataFinal={recurrenceModalData.event ? new Date(recurrenceModalData.event.data) : null}
              quantidade={1}
              cada={1}
              frequencia="m"
              ocorrencia={null}
              diasSemana={null}
              diasMes={null}
              mesAno={null}
              disabled={false}
              zIndex={props.zIndex + 2}
            />
            <Space h="lg" />
            <Group justify="right">
              <Button
                variant="outline"
                onClick={() => {
                  setRecurrenceModalData({ opened: false, event: null, sharedResidues: [] });
                }}
              >
                Fechar
              </Button>
              <Button
                leftSection={<IconCalendarRepeat size={18} />}
                loading={saving}
                onClick={async () => {
                  try {
                    const recurrence = refRecurrenceForm.current.validate();
                    await saveRecurring(
                      recurrenceModalData.event!,
                      recurrenceModalData.sharedResidues,
                      recurrence
                    );
                  } catch (error: any) {
                    showNotification({
                      title: 'Evento - Adicionar',
                      message: `Recorrência - ${error.message}`,
                      color: 'red',
                    });
                  }
                }}
              >
                Salvar Recorrência
              </Button>
            </Group>
          </Modal>

          <Paper shadow="xs" p="md" withBorder>
            {(dataResult?.eventData?.relacoes || [])?.findIndex((x) =>
              [Relacao.Substituicao, Relacao.Juncao].includes(x.codigoEventoRelacao)
            ) > -1 && (
              <Alert icon={<IconAlertTriangle size={16} />} title="Atenção!" color="yellow">
                Esse evento está relacionado à outro evento de substituição/junção.
              </Alert>
            )}
            <Tabs items={tabs} defaultActiveKey="Geral" />
          </Paper>
          <Space h="lg" />

          <Group justify="right">
            {props.idEvento && validate(Permission.EventView, currentUser.permissoes) && (
              <Button
                color="secondary"
                leftSection={<IconEye size={18} />}
                onClick={() =>
                  props.callback(
                    [{ ...buildFakeAuditObject(), ...dataResult.eventData }],
                    'visualizar',
                    null,
                    true,
                    props.extras
                  )
                }
                loading={saving}
                disabled={saving}
              >
                Visualizar
              </Button>
            )}
            {!props.idEvento ? (
              <Menu shadow="md" width={220} position="top-end">
                <Menu.Target>
                  <Button
                    leftSection={<IconDeviceFloppy size={18} />}
                    loading={saving}
                    hidden={!validate(Permission.EventAdd, currentUser.permissoes)}
                  >
                    Salvar
                  </Button>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={<IconDeviceFloppy size={16} />}
                    onClick={() => {
                      handleValidatedSubmit('single');
                    }}
                  >
                    Salvar
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconCalendarRepeat size={16} />}
                    onClick={() => {
                      handleValidatedSubmit('recurrence');
                    }}
                  >
                    Salvar Recorrência
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            ) : (
              <Button
                leftSection={<IconDeviceFloppy size={18} />}
                onClick={() => {
                  handleValidatedSubmit('single');
                }}
                loading={saving}
                hidden={!validate(Permission.EventEdit, currentUser.permissoes)}
              >
                Salvar
              </Button>
            )}
          </Group>
        </div>
      )}
    </div>
  );
}
